module.exports = __webpack_public_path__ + "media/images/icon_nav_search_white-f3b41a91ab9a2487cbde4b4d1b7be361.svg";